import ExamInformationMixin from '@/shared/mixins/exam-information.mixin'
import ExamObservation from '@/shared/mixins/exam-observation.mixin'
import DateMixin from '@/shared/mixins/date.mixin'
import RoleMixin from '@/shared/mixins/role.mixin'
import AuthMixin from '@/shared/mixins/auth.mixin'
import CONSTANTS from '../../../../shared/constants/constants'
import iconProfile from '@/assets/svg/profile.svg?raw'

export default {
  name: 'exam-details-information',
  props: {
    details: {
      type: Object,
      required: true
    }
  },
  mixins: [
    DateMixin,
    ExamInformationMixin,
    RoleMixin,
    AuthMixin,
    ExamObservation
  ],
  data () {
    return {
      instructionText: this.$i18n.t('type_here_pendency_answer'),
      listObservation: [this.$i18n.t('exam_reason'), this.$i18n.t('patient_clinical_history'), this.$i18n.t('medications_in_use')],
      STATUS: CONSTANTS.STATUS,
      informations: [],
      roles: [],
      iconProfile,
      creationDate: null,
      pendencyDescription: {},
      newInformation: '',
      modelEmergency: false
    }
  },
  computed: {
    formattedInformations () {
      if (!Array.isArray(this.informations) || !this.informations.length) return []

      return this.informations
        .slice()
        .sort((a, b) => new Date(a.creationDate) - new Date(b.creationDate))
        .map((information) => {
          const roleFound = this.roles.find((roleItem) => roleItem.name === information.role)

          return {
            examInformationId: information.examInformationId,
            role: roleFound ? roleFound.label : information.role,
            name: information.name || information.nameUser || '',
            text: information.text || information.content || '',
            creationDate: this.formatInformationDate(information.creationDate)
          }
        })
    },
    currentUser () {
      if (!this.roles.length) {
        return
      }

      const user = this.getUser()
      const currentRole = this.roles.find((role) => {
        return user.role.name === role.name
      })

      return {
        name: user.fullname,
        role: currentRole.label
      }
    },
    hasSendInformation () {
      const user = this.getUser()
      return (user.role.name === 'source') && (this.details.status.id === this.STATUS.AGUARDANDO_INFORMACAO)
    },
    isInvalid() {
      return this.newInformation.length > 0 && this.newInformation.length < 10
    },
    shouldShowPendencySection () {
      return (
        this.details?.status?.id === this.STATUS.AGUARDANDO_OBSERVACAO ||
        this.details?.status?.id === this.STATUS.AGUARDANDO_INFORMACAO ||
        this.details?.status?.id === this.STATUS.AGUARDANDO_LAUDO ||
        this.details?.status?.id === this.STATUS.LAUDO_LIBERADO ||
        this.details?.status?.id === this.STATUS.REPETIR
      )
    }
  },
  async mounted () {
    this.$root.$on('updateModelEmergency', (data) => this.updateModelEmergency(data))
    this.$root.$emit('showLoading')
    try {
      if (this.details.status.id === this.STATUS.AGUARDANDO_INFORMACAO || 
          this.details.status.id === this.STATUS.AGUARDANDO_LAUDO ||
          this.details.status.id === this.STATUS.LAUDO_LIBERADO ||
          this.details.status.id === this.STATUS.REPETIR) {
        const res = await Promise.all([this.getRoles(), this.getInformationsByExamId(this.details.examId)])
        this.roles = res[0]
        this.informations = res[1].data
      }
    } finally {
      this.$root.$emit('hideLoading')
    }
  },
  methods: {
    updateModelEmergency(modelEmergency) {
      this.modelEmergency = modelEmergency
    },
    clickStatus () {
      if (this.details.status.id === this.STATUS.AGUARDANDO_INFORMACAO || this.details.status.id === this.STATUS.AGUARDANDO_LAUDO) {
        this.clickSendInformation()
      } else {
        this.addObservation()
      }
    },
    async clickSendInformation (information) {
      this.$root.$emit('showLoading')
      try {
        this.informations = await this.sendInformation(this.details.examId, this.newInformation)

        this.$emit('sendInformation')
        this.$router.go()
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    pendencies () {
      const verify = this.qtdPendency >= 2 ? 2 : 1
      return this.$i18n.tc('pendencies', verify, { amount: this.qtdPendency })
    },

    async addObservation () {
      const observation = {
        content: this.newInformation,
        examId: this.details.examId,
        creationDate: this.getToday(),
        nameUser: this.getFullName()
      }

      this.$root.$emit('showLoading')
      try {
        const result = await this.addExamObservation(observation)
        const statusId = result.data.data.status.id
        this.details.observations = [observation]
        this.$emit('addObservation', statusId)
        this.$router.go()
      } finally {
        this.$root.$emit('hideLoading')
      }
    },
    formatInformationDate(isoDateString) {
      if (!isoDateString) return ''

      const date = new Date(isoDateString)

      const formatTwoDigits = (number) => String(number).padStart(2, '0')

      const formattedDate = `${formatTwoDigits(date.getDate())}/${formatTwoDigits(date.getMonth() + 1)}/${date.getFullYear()} - ${formatTwoDigits(date.getHours())}:${formatTwoDigits(date.getMinutes())}`

      const differenceInMs = Date.now() - date.getTime()
      const differenceInMinutes = Math.max(0, Math.floor(differenceInMs / 60000))

      let relativeTime
      if (differenceInMinutes < 60) {
        relativeTime = `${differenceInMinutes} ${differenceInMinutes === 1 ? 'minuto' : 'minutos'}`
      } else if (differenceInMinutes < 1440) {
        const differenceInHours = Math.floor(differenceInMinutes / 60)
        relativeTime = `${differenceInHours} ${differenceInHours === 1 ? 'hora' : 'horas'}`
      } else {
        const differenceInDays = Math.floor(differenceInMinutes / 1440)
        relativeTime = `${differenceInDays} ${differenceInDays === 1 ? 'dia' : 'dias'}`
      }
      return `${formattedDate} | ${relativeTime}`
    }
  }
}
